// extracted by mini-css-extract-plugin
export default {"modalContent":"_7prySR9Kt4Uz3tr7MCxA","modalBody":"_11uOihH3t7ZNSyU5ICRJMa","message":"Qql5yK8MJSUIg6VNpNXzG","error":"_7sQOtrUKhFyE8S9SKgjJ3","success":"_32r18p1Q7NW9TrVXWUzk7u"};